import styled from "styled-components";

export const StyledQuestionContainer = styled.div`
  padding: 16px;
  background-color: white;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  display: flex;
`;

export const StyledQuestionContainerHeader = styled.div`
  padding: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const StyledQuestionViewerTitle = styled.p`
  font-weight: 600;
  margin: 0;
`;
